// Angular
import {
	Component,
	OnDestroy,
	OnInit
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// State
import { Store } from '@ngxs/store';
// Model
import { SignalRState } from '../../../../signal-r/signal-r.state';
import { SIGNAL_STATUS } from '../../../../signal-r/model/signal-r.model';

@Component({
	selector: 'cv-real-time-status',
	templateUrl: './real-time-status.component.html',
	styleUrls: ['./real-time-status.component.scss']
})
export class RealTimeStatusComponent implements OnInit, OnDestroy {
	connectionStatus$: Observable<any> = this.store.select(SignalRState.connectionStatus);
	v1= false;

	private atComponentDestroy = new Subject();

	public connectionStatus: SIGNAL_STATUS = SIGNAL_STATUS.OFFLINE;
	public signalStatus = SIGNAL_STATUS;

	constructor(private store:Store) {}

	ngOnInit(): void {
		// Listen to every connection to the Server
		this.connectionStatus$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((connectionStatus: SIGNAL_STATUS) => {
				this.connectionStatus = connectionStatus;
			});
	}

	/**
	 * Close all Opened subscriptions
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
